import React from 'react';
import Ball from '@/common-pages/color/components/ball';
import {ALL_BALLS} from '@/common-pages/color/constant';
import {useTranslation} from 'react-i18next';
import Won from '../won/won';

export interface ColorResultProps {
  isOpen?: boolean;
  digitResult?: string;
  colorResult?: string;
  subsetList?: {
    amount: number;
    colorResult: string;
    selectValue: string;
    awardAmount: number;
  }[];
}

const ColorResult = ({
  isOpen,
  subsetList = [],
  colorResult,
  digitResult,
}: ColorResultProps) => {
  const winList = React.useMemo(() => {
    return subsetList?.filter(item => item.awardAmount > 0);
  }, [subsetList]);
  const {i18n} = useTranslation();
  return (
    <div className="mt-2">
      <div className="flex items-center justify-between bg-[#F4F4F4] px-3 py-2">
        <span className="text-sm font-bold">
          {i18n.t('bets-detail.label.drawRes')}：
        </span>
        <div>
          <Ball
            onlyColor={false}
            digit={isOpen ? digitResult! : '-'}
            color={isOpen ? colorResult : '*'}
            ballSize={32}
            fontColor={isOpen ? '#000' : '#fff'}
            fontSize={16}
          />
        </div>
      </div>
      <div
        className={`${winList?.length > 0 ? 'mt-2' : ''} flex flex-col gap-2`}>
        {winList?.map((item, _i) => {
          const color = !isNaN(Number(item.selectValue))
            ? ALL_BALLS.find(pie => pie.digit === item.selectValue)?.color
            : item.selectValue;
          return (
            <Won
              key={_i}
              result={
                <Ball
                  onlyColor={isNaN(Number(item.selectValue))}
                  digit={item.selectValue}
                  color={color}
                  ballSize={28}
                  fontColor={!isNaN(Number(item.selectValue)) ? '#000' : '#fff'}
                  fontSize={isNaN(Number(item.selectValue)) ? 6 : 14}
                />
              }
              bet={item.amount}
              awardAmount={item.awardAmount}
            />
          );
        })}
      </div>
      <div className="mt-2 flex justify-center gap-2">
        {subsetList?.map((item, _ii) => {
          const color = !isNaN(Number(item.selectValue))
            ? ALL_BALLS.find(pie => pie.digit === item.selectValue)?.color
            : item.selectValue;
          return (
            <Ball
              key={_ii}
              onlyColor={isNaN(Number(item.selectValue))}
              digit={item.selectValue}
              color={color}
              ballSize={28}
              fontColor={!isNaN(Number(item.selectValue)) ? '#000' : '#fff'}
              fontSize={isNaN(Number(item.selectValue)) ? 6 : 14}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ColorResult;
